<template>
  <div class="manufacturer-container">
    <div class="main-container">
      <div class="header-container">
        <div class="left">
          <el-input v-model="search" size="small" class="w-180" placeholder="名称"></el-input>
          <el-button type="primary" size="small" class="m-l-10" @click="getData">查询</el-button>
        </div>
        <div>
          <el-button type="primary" size="small" @click="addManufacturer">新增</el-button>
        </div>
      </div>
      <div class="table-container">
        <nk-table :columns="columns" :data="tableData" :showPage="true" :page="tablePage" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
          <el-table-column label="操作" :align="'center'">
            <template slot-scope="scope">
              <el-button type="text" @click="editManufacturer(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteManufacturer(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
    </div>

    <lt-msg-box :visible="addFormVisible" @cancel="addFormVisible = false" @confirm="saveAddForm" :title="'添加供应商'" :width="'500px'">
      <div class="form-container">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="addForm.address"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="tel">
            <el-input v-model="addForm.tel"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </lt-msg-box>

    <lt-msg-box :visible="editFormVisible" @cancel="editFormVisible = false" @confirm="saveEditForm" :title="'编辑供应商'" :width="'500px'">
      <div class="form-container">
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="editForm.address"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="tel">
            <el-input v-model="editForm.tel"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </lt-msg-box>
  </div>
</template>

<script>
import NkTable from '@/components/common/NkTable.vue'
import api from '../../../../../common/api'
import { toPage } from "@/utils/index";
import LtMsgBox from '@/components/common/LtMsgBox.vue';
export default {
  components: { NkTable, LtMsgBox },
  data () {
    return {
      search: '',
      columns: [
        { prop: 'name', label: '名称', show: true },
        { prop: 'address', label: '地址', show: true },
        { prop: 'tel', label: '电话', show: true },
      ],
      tableData: [],
      allTableData: [],
      tablePage: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 0,
      },
      addFormVisible: false,
      addForm: {},
      addFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
      },
      editFormVisible: false,
      editForm: {},
      editFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
      }
    }
  },
  created () {
    this.getData(1)
  },
  methods: {
    getData (pageIndex) {
      if (!(pageIndex instanceof Number)) {
        pageIndex = 1
      }
      let vm = this
      api.manufacturer.getManufacturer2(vm.search).then(res => {
        let allTableData = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].name.indexOf(vm.search) > -1) {
              allTableData.push(res.data[i])
            }
          }
          allTableData = res.data
        }
        vm.allTableData = allTableData
        vm.tablePage.pageIndex = pageIndex
        vm.getPageData()
      })
    },
    handleCurrentChange (val) {
      let vm = this
      vm.tablePage.pageIndex = val
      vm.getPageData()
    },
    handleSizeChange (val) {
      let vm = this
      vm.tablePage.size = val
      vm.tablePage.pageIndex = 1
      vm.getPageData()
    },
    getPageData () {
      let vm = this
      const obj = toPage(vm.allTableData, vm.tablePage.pageIndex, vm.tablePage.size)
      vm.tablePage.total = vm.allTableData.length
      vm.tableData = obj.arr
    },
    editManufacturer (index, row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editFormVisible = true
      this.$refs['editForm'].clearValidate()
    },
    addManufacturer () {
      this.addForm = {}
      this.addFormVisible = true
      this.$refs['addForm'].clearValidate()
    },

    // 删除供应商
    deleteManufacturer (index, row) {
      let vm = this
      vm.$confirm('此操作将永久删除该供应商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.manufacturer.deleteManufacturer(row.id).then(res => {
          if (res.success) {
            vm.$message("删除成功！")
            vm.getData(vm.tablePage.pageIndex)
          }
        })
      }).catch(() => {
      });
    },

    // 添加供应商
    saveAddForm () {
      let vm = this
      vm.$refs['addForm'].validate((valid) => {
        if (valid) {
          const { name, address, tel } = vm.addForm
          if (!(/^1[3|4|5|7|8]\d{9}$/.test(tel)) || !(/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/).test(tel)) {
            vm.$message.error("电话号码错误！请重填")
            return false;
          }
          api.manufacturer.addManufacturer(name, address, tel).then(res => {
            if (res.success) {
              vm.$message("添加成功！")
              vm.addFormVisible = false
              vm.getData(vm.tablePage.pageIndex)
            }
          })
        } else {
          return false;
        }
      });
    },
    // 修改供应商
    saveEditForm () {
      let vm = this
      vm.$refs['editForm'].validate((valid) => {
        if (valid) {
          const { id, name, address, tel } = vm.editForm
          if (!(/^1[3|4|5|7|8]\d{9}$/.test(tel)) || !(/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/).test(tel)) {
            vm.$message.error("电话号码错误！请重填")
            return false;
          }
          api.manufacturer.modifyManufacturer(id, name, address, tel).then(res => {
            if (res.success) {
              vm.$message("编辑成功！")
              vm.editFormVisible = false
              vm.getData(vm.tablePage.pageIndex)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.manufacturer-container {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .main-container {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    .header-container {
      display: flex;
      .left {
        display: flex;
        flex: 1;
      }
    }
    .table-container {
      flex: 1;
      margin-top: 10px;
    }
  }
}
.form-container {
  padding: 0px 14px;
}
.w-180 {
  width: 180px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-t-10 {
  margin-left: 10px;
}
</style>